import React, { useContext, useState, useEffect } from 'react';
import { InputField } from '@trp-beacon-ui-kit/react-controls';
import SectionHeading from '../Typography/SectionHeading/SectionHeading';
import EditButton from '../Typography/EditButton/EditButton';
import styles from './FONASUCustomerInformation.css';
import { FlowContext } from '../../core/flow-engine';

import { InternalAuthenticatorContext } from '../../context/InternalAuthenticatorContext/InternalAuthenticatorContext';
import FONASUCustomerReview from '../FONASUCustomerReview/FONASUCustomerReview';
import FONASUCustomerInformationSection from '../FONASUCustomerInformationSection/FONASUCustomerInformationSection';
import { extractPhoneNumberwithType } from '../../flows/shared/utils';
import { getSectionHeading, shouldDisableDoneBtn } from './util';

const CustomerReview = ({
  customer,
  phone1,
  phone2,
  phone3,
  amount,
  showInvestmentAmt
}) => {
  const {
    appState: {
      store: { mailingAddressDifferent }
    }
  } = useContext(FlowContext);
  return (
    <div>
      <FONASUCustomerReview
        customer={customer}
        phone1={phone1}
        phone2={phone2}
        phone3={phone3}
        mailingAddressDifferent={mailingAddressDifferent}
      />
      {showInvestmentAmt && (
        <div className="review-section">
          <div className="qv-row">
            <div className="qv-col">
              <div className="field-label">Investment Amount</div>
              <div className="field-value">
                ${Number(amount).toLocaleString('en-US')}
              </div>
            </div>
          </div>
        </div>
      )}
      <style jsx>{styles}</style>
    </div>
  );
};

const FONASUCustomerInformation = ({
  editCustomer,
  setEditCustomer,
  showSuccess,
  showInvestmentAmt
}) => {
  const {
    next,
    formProps,
    appState: {
      store: {
        amount,
        mailingAddressDifferent,
        accountType,
        app: { customer },
        loadedData: { customerInfoEditMode }
      }
    }
  } = useContext(FlowContext);
  const { phones } = customer;
  const associateID = useContext(InternalAuthenticatorContext);

  const phone1 = extractPhoneNumberwithType(phones, 'MOBILE');
  const phone2 = extractPhoneNumberwithType(phones, 'DAYTIME');
  const phone3 = extractPhoneNumberwithType(phones, 'EVENING');

  const [phoneNumberRequired, setPhoneNumberRequired] = useState(true);

  useEffect(() => {
    setEditCustomer(customerInfoEditMode);
  }, [customerInfoEditMode]);

  useEffect(() => {
    if (phone1 || phone2 || phone3) {
      setPhoneNumberRequired(false);
    }
  }, []);

  const disableDoneBtn = shouldDisableDoneBtn(showSuccess, phoneNumberRequired);

  const handleClick = async () => {
    if (editCustomer) {
      await next({
        section: 'addressValidation',
        associateLoginID: associateID
      })();
    } else {
      await next('unlockMyInfoSection')();
    }
  };

  const onKeyDown = event => {
    if (['.', '-'].includes(event.key)) event.preventDefault();
  };

  const sectionHeading = getSectionHeading(showInvestmentAmt, accountType);

  return (
    <div className="review-customer-information">
      <div className="section-header">
        <SectionHeading text={sectionHeading} />
      </div>

      {editCustomer ? (
        <div className="review-section">
          <FONASUCustomerInformationSection
            phone1={phone1}
            phone2={phone2}
            phone3={phone3}
            phoneNumberRequired={phoneNumberRequired}
            setPhoneNumberRequired={setPhoneNumberRequired}
            mailingAddressDifferent={mailingAddressDifferent}
          />
          {showInvestmentAmt && (
            <div className="qv-row">
              <div className="qv-col">
                <InputField
                  type="number"
                  maxLength="12"
                  step="1"
                  placeholder="$0"
                  title="Investment Amount"
                  {...formProps.amount}
                  defaultValue={amount}
                  onKeyDown={onKeyDown}
                />
              </div>
            </div>
          )}
        </div>
      ) : (
        <CustomerReview
          customer={customer}
          amount={amount}
          phone1={phone1}
          phone2={phone2}
          phone3={phone3}
          showInvestmentAmt={showInvestmentAmt}
        />
      )}
      <EditButton
        onClick={handleClick}
        currentlyEditing={editCustomer}
        disabled={disableDoneBtn}
      />
      <style jsx>{styles}</style>
    </div>
  );
};

export default FONASUCustomerInformation;
